import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Link } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSmsSetupContext } from '../../context/SmsSetupContext/SmsSetupContext';
import { dialogLinks } from '../../layout/AppLayout/constants';
import { useIsDesktop, useIsTablet } from '../../utils/mediaQueries';
import { ActionButton } from '../Button/Button';
import { Decoration } from './Decoration';
import styles from './styles';
export const SmsDecoration = ({ asStandAlonePage }) => {
    const { t: text } = useTranslation();
    const navigate = useNavigate();
    const { smsSetupContextState, setSmsSetupContextState } = useSmsSetupContext();
    const isDesktop = useIsDesktop();
    const isTablet = useIsTablet();
    const goToSmsSetup = async () => {
        setSmsSetupContextState({
            ...smsSetupContextState,
            smsSetupCurrentStep: 1,
        });
    };
    const handleSkip = async () => {
        navigate(dialogLinks.ONBOARDING_COMPLETED);
    };
    const ctaButtons = asStandAlonePage ? (_jsxs(Box, { sx: styles.ctaWrapper(isDesktop, isTablet), children: [_jsx(ActionButton, { type: 'primary', text: text('SET_UP_SMS_CTA'), onClick: () => {
                    goToSmsSetup();
                } }), _jsx(Link, { sx: styles.skipLink, onClick: () => {
                    handleSkip();
                }, tabIndex: 0, onKeyDown: (e) => {
                    if (e.key === 'Enter') {
                        handleSkip();
                    }
                }, children: text('SET_UP_SMS_SKIP_CTA') })] })) : (_jsx(_Fragment, {}));
    const imagePath = '/assets/images/sms-setup.svg';
    const title = text('SET_UP_SMS_DECO_TEXT');
    const titleBold = text('SET_UP_SMS_DECO_TEXT1');
    const decoText = asStandAlonePage ? text('SET_UP_SMS_DECO_TEXT3') : text('SET_UP_SMS_DECO_TEXT2');
    return (_jsx(Decoration, { asStandAlonePage, imagePath, title, titleBold, decoText, ctaButtons }));
};
